import * as React from "react"
import {statuses} from "./Config"
import {styled} from "@material-ui/core";

const STATUS_MAP = {
    faulty: 0,
    warning: 1,
    inactive: 2,
    healthy: 3,
    uninstalled: 4
}

const STATUS_PROPS = [
    statuses.faulty.label, statuses.faulty.colour,
    statuses.warning.label, statuses.warning.colour,
    statuses.inactive.label, statuses.inactive.colour,
    statuses.healthy.label, statuses.healthy.colour,
    statuses.uninstalled.label, statuses.uninstalled.colour
]

export const StatusChip = styled((props) => {
    const offset = STATUS_MAP[props.status] << 1
    return (
        <div className={props.className} style={{backgroundColor: STATUS_PROPS[offset + 1]}}>{STATUS_PROPS[offset]}</div>
    )
})( {
    height: "2em",
    borderRadius: "1em",
    lineHeight: "2em",
    display: "inline-block",
    padding: "0 2em",
    color: "#fff"
})

const TICKET_STATUSES = {
    "New": "#FFB057",
    "Open": "#E34F32",
    "Pending": "#3091EC",
    "Solved": "#87929D",
    "On-hold": "#4A545B",
    "Closed": "#87929D"
}

export const TicketStatusChip = styled(({status, children, ...props}) => {
    return (
        <div className={props.className}><div style={{backgroundColor: TICKET_STATUSES[status]}}/>{children}</div>
    )
})({
    display: "flex",
    alignItems: "center",
    "& > div:last-of-type":{
        marginRight: "4px",
        width: "1em",
        minWidth: "1em",
        height: "1em"
    }
})
